module.exports = __webpack_public_path__ + "homeStatic/img/ter4yovrm.07d5e0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/ter4yovrm.png
// module id = ONhZ
// module chunks = 1